import { SkeletonBox } from '@practium/ui';
import styles from './FarmCardSkeleton.module.css';

export const FarmCardSkeleton = () => (
	<div className={styles.card}>
		<SkeletonBox width="5rem" height="5rem" borderRadius="1rem" />
		<div className={styles.info}>
			<SkeletonBox width="65%" height="1.1rem" />
			<SkeletonBox width="45%" height="0.85rem" />
		</div>
	</div>
);
